
import { camelToKebab, camelToSnake, camelToVue } from './utils.mjs'
import { registerVueComponent, vrunAutoNgVueWraper } from './vvuejs.parcel.mjs'
import { declareVrunModule } from '/vodalys/vvuejs'

import { debug } from '/vodalys/.jslibs'

const log = debug('vue:declareVrunComponent')


/**
 * Déclare un composant vrun, avec tous les bindings angular, vuejs et vodalysform qui vont bien
 * @param {string} name - le nom du composant  en camel case (monComponentName)
 * @param {(component | function)} component - le composant  vue ou une fonction de la forme () => import('./monComponent.vue) 
 * @param {string} [o] type - un type vform facultatif, au cas ou le type form ne corespond vraiment pas au nom du composant 
 */
export function declareVrunComponent(name, component, type, instanceFunction = null) {

    
    type ??= name

    const shortName = name.split('.')[0]
    const vueName = camelToVue(shortName)
    const kebabName = camelToKebab(name)
    const snakeName = camelToSnake(name)
    const vrunModuleName = `${camelToSnake(shortName)}.vrun`

    log(`declare ${typeof component === 'function' ? 'async' : 'sync'} component`, name, {name, type, shortName, vueName, kebabName, snakeName, vrunModuleName})

    // enregistre le component vue associer au type vfields.inc (kebabName)
    registerVueComponent(kebabName, vueName, component)

    // Déclare et enregistre un component angular qui wrapp le component vue
    const ngModule = declareVrunModule(vrunModuleName, instanceFunction);
    vrunAutoNgVueWraper(ngModule, name, shortName, component)
}
